import React, { useEffect } from "react";

const NotificationModal = ({ isOpen, message, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose(); // Automatically close after 3 seconds
      }, 3000);
      return () => clearTimeout(timer); // Cleanup timer on unmount or state change
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-100">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold">Notification</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 rounded-full p-1"
          >
            ✕
          </button>
        </div>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default NotificationModal;
